import React, { useEffect, useState } from 'react'
import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import NavBar from '../../components/NavBar';
import HeaderPage from '../../components/HeaderPage';
import getDecryptData from '../../../helper/getDecryptData';
import axiosInstance, { weburl } from '../../../axiosInstance';

const AccountMonthly = () => {

  const decryptdatajson = getDecryptData();

  const { dataAuth, IsUserData, Headers } = useBlogContext();



  const [Loading, setLoading] = useState(true);
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [Transaction, setTransaction] = useState([]);

  const [Locking, setLocking] = useState(true);


  useEffect(() => {
    // Function to check if user's gold locking period has expired
    const isGoldLockingExpired = (lockingArray, noOfDays = 30) => {
      if (!lockingArray || lockingArray.length === 0) return true; // No locking, can invest

      // Get the latest locking entry (assuming last entry is the latest)
      const latestLock = lockingArray[lockingArray.length - 1];
      const lockDate = new Date(latestLock.date);

      // Calculate the difference in days
      const now = new Date();
      const diffTime = now - lockDate; // difference in milliseconds
      const diffDays = diffTime / (1000 * 60 * 60 * 24); // convert to days

      return diffDays >= noOfDays;
    };

    // Example usage
    if (IsUserData.locking) {
      const LockingExpired = isGoldLockingExpired(IsUserData.locking, Headers.noOfDays);
      setLocking(LockingExpired);
    }


  }, [Headers, IsUserData]);


  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: "2-digit", minute: "2-digit" };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };

  const [sortOrder, setSortOrder] = useState(1); // 1 for Newest, 2 for Oldest
  const [filterRange, setFilterRange] = useState("all"); // 'all', 'today', '7days', '1month'

  const handleSortChange = (event) => {
    setSortOrder(parseInt(event.target.value));
  };

  const handleFilterChange = (event) => {
    setFilterRange(event.target.value);
  };

  const getActiveFourteenPlusOnePlan = (transactions = []) => {
    const sortedTransactions = [...transactions].sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
    const lastBonusIndex = sortedTransactions
      .map((transaction) => transaction.monthlyPlan)
      .lastIndexOf("admin_bonus");
    const cycleTransactions = sortedTransactions.slice(lastBonusIndex + 1);
    const starterIndex = cycleTransactions.findIndex(
      (transaction) =>
        transaction.monthlyPlan === "14plus1" ||
        transaction.note?.includes("(14+1)")
    );

    if (starterIndex === -1) return null;

    const starter = cycleTransactions[starterIndex];
    const eligiblePayments = cycleTransactions
      .slice(starterIndex)
      .filter(
        (transaction) =>
          transaction.monthlyPlan !== "admin_bonus" &&
          Number(transaction.amount) === Number(starter.amount)
      );

    if (eligiblePayments.length >= 14) return null;

    return {
      amount: Number(starter.amount),
      paidCount: eligiblePayments.length,
    };
  };

  const [formData, setFormData] = useState({
    userId: null,
    type: 0,
    note: `Add Funds By ${decryptdatajson.username} `,
    amount: 0,
    wallet: 0,
    trans: 0,
    monthlyPlan: "regular",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  //form handle



  const fetchtransactionById = async () => {
    const decryptdatajson = await getDecryptData();

    const id = decryptdatajson._id;

    try {
      setLoading(true);

      const { data } = await axiosInstance.get(`/all-transaction/${id}?type=3`);
      const { success } = data;

      if (success) {
        const transactions = data.transactions.reverse();
        const activeFourteenPlusOnePlan = getActiveFourteenPlusOnePlan(transactions);
        setTransaction(transactions);
        if (activeFourteenPlusOnePlan) {
          setFormData((prevData) => ({
            ...prevData,
            monthlyPlan: "14plus1",
            wallet: activeFourteenPlusOnePlan.amount || prevData.wallet,
          }));
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
      // Handle network errors, API issues, etc.
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchtransactionById();
    dataAuth();
  }, []);

  useEffect(() => {
    if (formData.trans) {
      setTransaction(Transaction.reverse());
      console.log("formData.trans", formData.trans);
    }
  }, [formData.trans]);


  const handleSubmit = async () => {
    const decryptdatajson = await getDecryptData();

    const total = Number(formData.wallet);
    const userId = decryptdatajson._id;

    if (total < 1000) {
      toast.error('Adding less than 1000 is not allowed!');
      return;
    }

    // Start loading before the submission process
    setSubmitLoading(false);

    // Prepare data for submission
    const updatedFormData = {
      userId: userId,
      Amount: total,  // Round the value of total / 2
      monthlyPlan: formData.monthlyPlan,
    };

    try {


      // Send the data to the backend

      const data = await axiosInstance.post(`/mothly-invest`, updatedFormData);

      console.log('dataaa', data)
      const { success, razorpay_order_id, keyId } = data.data;
      if (success) {

        const options = {
          key: keyId,
          amount: Math.round(total * 100), // ✅ Razorpay expects amount in paise
          currency: "INR",
          name: Headers?.meta_title || 'unknown',
          description: Headers?.meta_description || 'unknown',
          image: Headers.meta_logo,
          order_id: razorpay_order_id,
          callback_url: `${weburl}mothly-payment-verification`,
          // prefill: {
          //   name: "test gupta",
          //   email: "test@gmail.com",
          //   contact: "1234567890",
          // },
          notes: {
            address: "razorapy official",
          },
          theme: {
            color: "#3399cc",
          },
        };
        const razor = new window.Razorpay(options);
        razor.open();


      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }



    } catch (error) {
      console.error("Error On payment:", error);
    } finally {
      // Stop loading after the submission process finishes
      setSubmitLoading(true);
    }


  };

  const prices = [
    1000,
    2000,
    5000,
    10000,
    15000,
  ]
  const setWalletAmount = (amt) => {
    setFormData((prevData) => ({
      ...prevData,
      wallet: amt,
    }));
  }

  const latestLockingAmount = IsUserData?.locking?.length
    ? IsUserData.locking[IsUserData.locking.length - 1]?.amount
    : null;

  return (
    <>
      <HeaderPage title={'Monthly Investment'} />

      <main className="page-content  mypadding overflow-auto pb-4 px-0" >


        {!Loading ? (
          <>
            <div className="container">
              <div className="rewards-box">
                <h5 className="sub-title">
                  My Investment
                  <span className="icon-bx">
                    <i className="feather icon-info" />
                  </span>
                </h5>
                <h2 className="title">
                  {SubmitLoading ? (
                    (IsUserData?.investment?.$numberDecimal || 0) + " gm"

                  ) : (
                    <>
                      <div className=" rounded">
                        <div
                          className="skeleton m-auto"
                          style={{ height: 80, width: "100%" }}
                        />
                      </div>
                    </>
                  )}
                </h2>


                {SubmitLoading ? (
                  <>
                    <button
                      type="button"
                      className="btn redeem-btn px-1 me-2"
                    // onClick={RefreshAllData}
                    >
                      <i className="ri-restart-line fs-2"></i>
                    </button>
                    <button
                      type="button"
                      className="btn redeem-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#walletModal"
                    >
                      Add
                    </button>
                  </>
                ) : (
                  <button className="btn redeem-btn" type="button" disabled>
                    <span className="ms-1">Loading...</span>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </button>
                )}



                <div className="bg-icon">
                  <img src="assets/images/svg/rewards.svg" alt="images" />
                </div>
              </div>
              <div className="title-bar">
                <h5 className="title">All Investment</h5>

              </div>
              <div className="rewards-list">
                <ul>
                  {Transaction.map((transaction) => (
                    <li key={transaction._id}>
                      <div className="item-head">
                        <h6 className="title">
                          <span
                            className={`${transaction?.type === 1 && "text-danger "
                              }`}
                          >
                            {" "}
                            {transaction?.note}{" "}
                          </span>
                        </h6>
                        <div className="dz-meta">
                          <ul>
                            <li className="text-white">{formatDate(transaction?.createdAt)}</li>
                            <li className="text-white">{formatTime(transaction?.createdAt)}</li>
                          </ul>
                        </div>
                      </div>
                      <div className="pts-bx">
                        <h4
                          className={`points text-${transaction.type !== 1 ? "primary" : "danger"
                            }`}
                        >
                          {transaction.amount >= 0 ? "+" : "-"}
                          {Math.abs(transaction.amount)}
                        </h4>

                        <p>Funds</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>


            <div className="modal fade" id="walletModal">
              <div className="bg-dark-shadow-fix "></div>
              <div className="modal-dialog " role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Investment</h5>
                    <button className="btn-close" data-bs-dismiss="modal">
                      <i className="fa-solid fa-xmark" />
                    </button>
                  </div>
                  <div className="modal-body ">
                    {Locking && (
                      <div className="d-flex gap-2 mb-3">
                        <button
                          type="button"
                          onClick={() => setFormData((prevData) => ({ ...prevData, monthlyPlan: "regular" }))}
                          className={`btn btn-sm ${formData.monthlyPlan === "regular" ? "btn-primary" : "btn-outline-dark"}`}
                        >
                          Regular
                        </button>
                        <button
                          type="button"
                          onClick={() => setFormData((prevData) => ({ ...prevData, monthlyPlan: "14plus1", wallet: "" }))}
                          className={`btn btn-sm ${formData.monthlyPlan === "14plus1" ? "btn-primary" : "btn-outline-dark"}`}
                        >
                          14+1
                        </button>
                      </div>
                    )}
                    <div className="mb-2 input-group input-group-icon ">
                      <span className="input-group-text bg-transparent">
                        <div className="input-icon">
                          <i className="ri-wallet-fill text-white"></i>
                        </div>
                      </span>
                      <input
                        type="number"
                        className="form-control ps-2"
                        placeholder="Enter Amount"
                        id="wallet"
                        value={formData.wallet !== 0 ? formData.wallet : ""}
                        name="wallet"
                        onChange={handleChange}
                        disabled={!Locking}
                        min="1000"
                      />
                    </div>
                    <div className="d-block mt-3 ">

                      {Locking && formData.monthlyPlan === "regular" ?


                        prices.map(price => (
                          <button key={price} onClick={() => setWalletAmount(price)} className="btn btn-outline-dark py-2 px-3 rounded mb-2 btn-sm me-2 font-15"
                          >{price}</button>
                        ))


                        : !Locking ?
                          <>
                            <button
                              type="button"
                              onClick={() => setWalletAmount(latestLockingAmount || formData.wallet || 1000)}
                              className="badge py-2 px-3 badge-pill badge-dark me-2 rounded-sm font-15"
                            >
                              {latestLockingAmount || formData.wallet || 1000}
                            </button>
                            {formData.monthlyPlan === "14plus1" && (
                              <p className="mb-0 mt-2 font-13 text-white">
                                Continuing 14+1 plan.
                              </p>
                            )}
                          </>
                          : (
                            <p className="mb-0 font-13 text-white">
                              Pay any amount for 14 installments. 1 matching installment is added by admin after 14 successful payments.
                            </p>
                          )
                      }


                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-sm btn-danger light"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-sm btn-primary"
                      onClick={handleSubmit}
                    >
                      Pay Now
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <br /> <br /> <br />
          </>
        ) : (
          <>
            <div className="container pt-0">
              <div
                className="skeleton mb-4 me-4"
                style={{ height: 197, width: "100%" }}
              />
              <div
                className="skeleton m-auto mb-4"
                style={{ height: 80, width: "100%" }}
              />
              <div
                className="skeleton m-auto mb-4"
                style={{ height: 80, width: "100%" }}
              />
              <div
                className="skeleton m-auto mb-4"
                style={{ height: 80, width: "100%" }}
              />
              <div
                className="skeleton m-auto mb-4"
                style={{ height: 80, width: "100%" }}
              />
              <br /> <br /> <br />
            </div>
          </>
        )}



        <NavBar />

      </main>
    </>
  )
}

export default AccountMonthly
